import { Box } from '@mui/material';
import useGetProductDetailsFilters from '../components/filters/ProductFilters/hook/useGetProductDetailsFilters';
import ProductColorFilter from './ProductColorFilter';

interface ProductDetailsFilterParams {
  allColorIds?: string[];
  productColorCode: string;
  productColorName: string;
}

const ProductDetailsFilter = ({
  allColorIds,
  productColorCode,
  productColorName,
}: ProductDetailsFilterParams) => {
  const { filters } = useGetProductDetailsFilters({ allColorIds: allColorIds || [] });

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        flexDirection: 'row',
        alignItems: 'flex-end',
        overflow: 'hidden',
      }}
    >
      {filters?.colors && (
        <ProductColorFilter
          colors={filters?.colors}
          productColorCode={productColorCode}
          productColorName={productColorName}
        />
      )}
    </Box>
  );
};
export default ProductDetailsFilter;
